import { render } from "./AutomationWizardPanelFooter.vue?vue&type=template&id=56d3748c&scoped=true"
import script from "./AutomationWizardPanelFooter.vue?vue&type=script&lang=js"
export * from "./AutomationWizardPanelFooter.vue?vue&type=script&lang=js"

import "./AutomationWizardPanelFooter.vue?vue&type=style&index=0&id=56d3748c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56d3748c"]])

export default __exports__